import { formatNumber } from '@search/helpers/src/formatNumber';
import { Currency } from '@search/filter-enums/enums/Currency';
import { currencyMapping } from '@search/filter-enums/mappings/currency_mapping';
import { OfferType, OfferTypeSimply } from '../../../domain/offer/search/page/OfferQuery';
import { OfferSnippetModel, priceCompat } from '../../../domain/offer/search/page/SearchOffersQuery';
import { isPresent } from '../../../domain/domainHelpers';

type CallbackSource = 'offer' | 'popup';

const callbackSourceLables: Record<CallbackSource, string> = {
    offer: 'Карточка объявления',
    popup: 'Карточка ЖК'
};

export function formatCallbackMailExtra(
    offer: OfferTypeSimply | OfferSnippetModel,
    source: CallbackSource
) {
    if (offer.realtyObject?.__typename !== 'ProfOfferFlat' || offer.dealType?.__typename !== 'ProfOfferDealSell') {
        return '';
    }

    const buildingId = offer.realtyObject?.building?.buildingId;
    const buildings = offer.newBuildingCard?.buildings;
    const price = priceCompat(offer.dealType);

    const priceValue = price!.rubPrice ?? price!.value;
    const priceCurrency = price!.rubPrice ? Currency.RUB : price!.currency;

    const priceStr = `${formatNumber(priceValue)} ${currencyMapping[priceCurrency]}`;

    const building = buildings?.find(b => b.id === buildingId);

    const data = [
        {
            name: 'Корпус',
            value: building?.address
        }, {
            name: 'Количество комнат',
            value: offer.realtyObject.roomsCount ?? ''
        }, {
            name: 'Площадь',
            value: offer.realtyObject.totalArea?.formatted
        }, {
            name: 'Этаж',
            value: offer.realtyObject.floor
        }, {
            name: 'Цена',
            value: priceStr
        }, {
            name: 'Источник',
            value: callbackSourceLables[source]
        }
    ];

    const resultString = data
        .filter(isPresent)
        .map(({ name, value }) => `${name}: ${value!}`)
        .join('\n');

    return resultString;
}
